import { render, staticRenderFns } from "./withdrawMoneyInfo.vue?vue&type=template&id=4505f6fb&scoped=true&"
import script from "./withdrawMoneyInfo.vue?vue&type=script&lang=js&"
export * from "./withdrawMoneyInfo.vue?vue&type=script&lang=js&"
import style0 from "./withdrawMoneyInfo.vue?vue&type=style&index=0&id=4505f6fb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505f6fb",
  null
  
)

export default component.exports